import { ToastItem, ToastType } from '@customTypes/toast';

export const DEFAULT_ERROR_CONTENT =
  'Something went wrong. Please try again, or return later. If the problem recurs, contact support@myome.com.';

export const BLOCKED_BY_BROWSER_CONTENT =
  'An action was blocked by your browser. Check your browser settings, try another browser, or contact support@myome.com for assistance.';

export const ERROR_TOAST_BY_CODE: Record<number, Omit<ToastItem, 'id'>> = {
  400: {
    headerTitle: 'Invalid Request',
    content: 'Please check your information and try again.',
    variant: 'danger',
  },
  408: {
    type: ToastType.CUSTOM_ACTIONS,
    headerTitle: 'Request Timeout',
    content: 'The request took too long to process. Please try again.',
    variant: 'warning',
  },
  409: {
    headerTitle: 'Duplicate Order',
    content:
      'An order with this information already exists. Please check your previous orders or contact support@myome.com if you need assistance.',
    variant: 'warning',
  },
  422: {
    headerTitle: 'Validation Error',
    content: 'Please check your information and try again. If the problem persists, contact support@myome.com.',
    variant: 'danger',
  },
  500: {
    headerTitle: 'Server Error',
    content: 'There was an error processing your request. Please try again or contact support@myome.com.',
    variant: 'danger',
  },
  503: {
    headerTitle: 'Service Unavailable',
    content: 'Our service is temporarily unavailable. Please try again in a few minutes.',
    variant: 'warning',
  },
};
